import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Layout from './components/Layout/Layout';
import HomePage from './pages/HomePage';
import { WHATSAPP_LINKS } from './config/whatsapp';

function App() {
  return (
    <Router>
      <Layout whatsappLink={WHATSAPP_LINKS.focoseg}>
        <HomePage />
      </Layout>
    </Router>
  );
}

export default App;
